import { Routes, Route, Navigate } from 'react-router-dom';
import DonationLanding from './pages/DonationLanding';
import DonationSuccess from './pages/DonationSuccess';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import PhoneCaseOrder from './pages/PhoneCaseOrder';
import ReceiptRequest from './pages/ReceiptRequest';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminDonations from './pages/AdminDonations';
import AdminSettings from './pages/AdminSettings';
import AdminMediaCoverage from './pages/AdminMediaCoverage';
import AdminStudentStories from './pages/AdminStudentStories';
import AdminEvents from './pages/AdminEvents';
import AdminDonationDetail from './pages/AdminDonationDetail';
import AdminDonors from './pages/AdminDonors';
import AdminMonthlyPledges from './pages/AdminMonthlyPledges';
import AdminPledgeDetail from './pages/AdminPledgeDetail';
import AdminBroadcastTasks from './pages/AdminBroadcastTasks';
import AdminBroadcastDetail from './pages/AdminBroadcastDetail';
import AdminAhJimUpsell from './pages/AdminAhJimUpsell';
import AdminAhJimStudio from './pages/AdminAhJimStudio';
import AdminAhJimIllustrations from './pages/AdminAhJimIllustrations';
import AdminTestimonials from './pages/AdminTestimonials';
import AdminMediaLibrary from './pages/AdminMediaLibrary';
import AdminSystemMessageTemplates from './pages/AdminSystemMessageTemplates';
import AdminMessageLogs from './pages/AdminMessageLogs';
import AdminPhoneCaseOrders from './pages/AdminPhoneCaseOrders';
import AdminReceiptRequests from './pages/AdminReceiptRequests';
import AdminLayout from './components/layout/AdminLayout';

function ProtectedAdminRoute({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem('admin_token');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return <AdminLayout>{children}</AdminLayout>;
}

function AdminFallbackRoute() {
  const token = localStorage.getItem('admin_token');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return (
    <ProtectedAdminRoute>
      <AdminDashboard />
    </ProtectedAdminRoute>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<DonationLanding />} />
      <Route path="/success" element={<DonationSuccess />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/phone-case-order" element={<PhoneCaseOrder />} />
      <Route path="/receipt-request" element={<ReceiptRequest />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedAdminRoute>
            <AdminDashboard />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/donations"
        element={
          <ProtectedAdminRoute>
            <AdminDonations />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/donations/:id"
        element={
          <ProtectedAdminRoute>
            <AdminDonationDetail />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/donors"
        element={
          <ProtectedAdminRoute>
            <AdminDonors />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/settings"
        element={
          <ProtectedAdminRoute>
            <AdminSettings />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/monthly-pledges"
        element={
          <ProtectedAdminRoute>
            <AdminMonthlyPledges />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/monthly-pledges/:id"
        element={
          <ProtectedAdminRoute>
            <AdminPledgeDetail />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/broadcast-tasks"
        element={
          <ProtectedAdminRoute>
            <AdminBroadcastTasks />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/broadcast-tasks/:id"
        element={
          <ProtectedAdminRoute>
            <AdminBroadcastDetail />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/ahjim-upsell"
        element={
          <ProtectedAdminRoute>
            <AdminAhJimUpsell />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/ahjim-quotes"
        element={
          <ProtectedAdminRoute>
            <AdminAhJimStudio />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/ahjim-illustrations"
        element={
          <ProtectedAdminRoute>
            <AdminAhJimIllustrations />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/testimonials"
        element={
          <ProtectedAdminRoute>
            <AdminTestimonials />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/media-library"
        element={
          <ProtectedAdminRoute>
            <AdminMediaLibrary />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/media-coverage"
        element={
          <ProtectedAdminRoute>
            <AdminMediaCoverage />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/stories"
        element={
          <ProtectedAdminRoute>
            <AdminStudentStories />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/events"
        element={
          <ProtectedAdminRoute>
            <AdminEvents />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/system-message-templates"
        element={
          <ProtectedAdminRoute>
            <AdminSystemMessageTemplates />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/message-logs"
        element={
          <ProtectedAdminRoute>
            <AdminMessageLogs />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/phone-case-orders"
        element={
          <ProtectedAdminRoute>
            <AdminPhoneCaseOrders />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/receipt-requests"
        element={
          <ProtectedAdminRoute>
            <AdminReceiptRequests />
          </ProtectedAdminRoute>
        }
      />
      <Route path="/admin/*" element={<AdminFallbackRoute />} />
      {/* 確保未知路徑重定向到首頁，保持路由完整性 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
